import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IExternalLinkProps } from '../components/external-link/external-link';

export class ExternalLinkModel extends ContentItem {
  get url(): string {
    return get(this._config, 'elements.url_address.value', '');
  }

  get blank(): boolean {
    return get(this._config, 'elements.blank.value[0].codename') === 'true';
  }

  public static create(data: IExternalLink): IExternalLinkProps {
    const { url, blank } = new ExternalLinkModel(data);
    return {
      url,
      blank
    };
  }
}
